var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('wxlogin',{attrs:{"appid":'wx5a3d790df36c54bc',"scope":'snsapi_login',"redirect_uri":'http://i-wq.net'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }